import { AdminDepartment } from "@/models/admin-department";
import { Department } from "@/utils/department";

export class Admin {
	id:number;
	email:string;
	name:string;
	firstName: string;
	imageUrl:string;
	departments:AdminDepartment[] = [];
	permissions:string[] = [];

	constructor(data:any) {
		this.id = data.id;
		this.email = data.email;
		this.name = data.name;
		this.firstName = this.name.split(" ")[0];
		this.imageUrl = data.imageUrl;
		if (data.departments) {
			this.departments = data.departments.map((d:any) => new AdminDepartment(d));
		}
		this.permissions = data.permissions ? [...data.permissions] : [];
	}

	isInDepartment(dep:Department):boolean {
		for (let adminDep of this.departments) {
			if (adminDep.departmentId == dep) {
				return true;
			}
		}
		return false;
	}

	hasPermission(permission:string):boolean{
		let [mainPermission, subPermission] = permission.split(".");
		for (let p of this.permissions){
			if (p == "admin") {
				return true;
			}
			let [thisMainPermission, thisSubPermission] = p.split(".");
			if (mainPermission == thisMainPermission) {
				if (!thisSubPermission) {
					return true;
				}
				if (thisSubPermission == subPermission) {
					return true;
				}
			}
		}
		return false;
	}
}